import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "../pages/Login";
import Dashboard from "../pages/DeliveryHome";
import BatchDetails from "../pages/BatchDetails";
import OrderDetails from "../pages/OrderDetails";
import DeliveryAccount from "../pages/DeliveryAccount";
import Orders from "../pages/Orders";

import ProtectedRoute from "./ProtectedRoute";

import DeliveryLayout from "../components/DeliveryLayout";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>

        {/* 🔐 PUBLIC */}
        <Route path="/" element={<Login />} />

        {/* 🔒 PROTECTED + LAYOUT */}
        <Route
          element={
            <ProtectedRoute>
              <DeliveryLayout />
            </ProtectedRoute>
          }
        >

          {/* 🏠 Dashboard */}
          <Route path="/dashboard" element={<Dashboard />} />

          {/* 📦 Batch */}
          <Route path="/batch/:id" element={<BatchDetails />} />

          {/* 📄 Order */}
          <Route path="/order/:id" element={<OrderDetails />} />

          {/* 👇 ADD ORDERS ROUTE 👇 */}
          <Route path="/orders" element={<Orders />} />

          {/* 👤 Account */}
          <Route path="/DeliveryAccount" element={<DeliveryAccount />} />

        </Route>

        {/* fallback */}
        <Route path="*" element={<Navigate to="/" />} />

      </Routes>
    </BrowserRouter>
  );
}